export const CONSTANTS = {
	//API RESPONSE
	HTTP_RESPONSE: {
		SUCCESS: 200,
		BAD_REQUEST: 400,
		NOT_FOUND: 404,
		UNAUTHORIZED: 401,
		INPROCESSIBLE: 422,
		SERVER_ERROR: 500,
	},
	POPUP_TYPE: {
		TERMS: 'TERMS_POPUP',
		PRIVACY: 'PRIVACY_POPUP',
	},
	PRODUCT_JOURNEYS: {
		DIRECT_CHECKOUT: 'show_direct_checkout',
		CATALOG_WITH_PRODUCT: 'show_catalogue_with_products',
		CATALOG_WITHOUT_PRODUCT: 'show_catalogue_without_products',
	},
	ERROR_TYPE: {
		TOAST: 'TOAST',
		ALERT: 'ALERT',
	},
	//GENERAL
	LANG_DIRECTION: {
		LTR: 'ltr',
		RTL: 'rtl',
	},
	IS_URDU: 'ur',
	IS_ENGLISH: 'en',
	YES: 1,
	NO: 0,
	CART: {
		ITEM_ADDED: 'ADD',
		INCREASE_QTY: 'ADDED',
	},
	ADD_QTY: 'ADD_QTY',
	SUB_QTY: 'SUB_QTY',
	DELETE_ITEM: 'DELETE_ITEM',
	DELIVERY_TYPE: {
		PICKUP: 1,
		PURCHASE: 2,
	},
	DEVICE_TYPE: {
		MOBILE: 'MOBILE',
		WEB: 'WEB',
	},
	APP_ALERT_TYPE: {
		DEFAULT: 1,
		CUSTOM: 2,
	},
}
